import { Box } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import Introduction from "./Global/Introduction";
import Objectives from "./Global/Objectives";
import DataHistory from "./Global/DataHistory";
import Principles from "./Global/Principles";
import MethodologyGuide from "./Global/MethodologyGuide";
import Glossary from "./Global/Glossary";
import TermsOfUse from "./Global/TermsOfUse";
import CompanyInfo from "./Global/CompanyInfo";
import { useLocation } from "react-router";
import { CloseFullscreen } from "@mui/icons-material";
import {
  useQueryGetListOfPrinciple,
  useQueryGetQuestionsOfPrinciples,
  useQueryGetUserDocumentStatus,
} from "../hooks/react-query/useData";
import SinglePrinciple from "./Global/SinglePrinciple";
import Reportes from "./Global/Reportes";
import axios from "axios";

const ToolGuide = () => {
  const [selectedComponent, setSelectedComponent] = useState(<Introduction />);
  const [selectedItem, setSelectedItem] = useState("Introducción");
  const [principlesDropdown, setPrinciplesDropdown] = useState(false);
  const [allPrinciplesData, setAllPrinciplesData] = useState([]);

  const location = useLocation();
  const { data: userDocumentStatus } = useQueryGetUserDocumentStatus();
  const { data: listOfPrinciples } = useQueryGetListOfPrinciple();

  const containerRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/api/principal/`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem("auth_token")}`,
            },
          }
        );
        setAllPrinciplesData(
          response?.data?.data.map((principle) => principle?.title)
        );
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (
      location?.state?.selectedOption?.name ===
      "Guía de herramienta huella de comunicación"
    ) {
      setSelectedComponent(<Introduction />);
      setSelectedItem("Introducción");
    } else if (
      location?.state?.selectedOption?.name === "Información de la empresa"
    ) {
      setSelectedComponent(<CompanyInfo />);
      setSelectedItem("Información de la empresa");
    } else if (location?.state?.selectedOption?.name === "Histórico de data") {
      setSelectedComponent(<DataHistory />);
      setSelectedItem("Histórico de data");
    }
  }, [location?.state?.selectedOption]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [selectedComponent]);

  const handleItemPrinciples = (item) => {
    setSelectedItem(item?.title);
    setSelectedComponent(<SinglePrinciple item={item} />);
  };
  const handleItemClick = (item) => {
    setSelectedItem(item);
    switch (item) {
      case "Información de la empresa":
        setSelectedComponent(
          <CompanyInfo userDocumentStatus={userDocumentStatus} />
        );
        break;
      case "Introducción":
        setSelectedComponent(<Introduction />);
        break;
      case "Objetivos":
        setSelectedComponent(<Objectives />);
        break;
      case "Principios":
        setSelectedComponent(
          <Principles listOfPrinciples={listOfPrinciples} />
        );
        break;
      case "Metodología y guía":
        setSelectedComponent(<MethodologyGuide />);
        break;
      case "Glosario":
        setSelectedComponent(<Glossary />);
        break;
      case "Condiciones de uso":
        setSelectedComponent(<TermsOfUse />);
        break;

      case "Reportes":
        setSelectedComponent(<Reportes />);
        break;
      case "Histórico de data":
        setSelectedComponent(<DataHistory />);
        break;
      default:
        setSelectedComponent(null);
        break;
    }
  };
  const handlePagesNavigation = () => {
    const pageFlow = [
      "Información de la empresa",
      "Introducción",
      "Objetivos",
      "Principios",
      "Metodología y guía",
      "Glosario",
      "Condiciones de uso",
      "Reportes",
    ];

    const principleFlow = [
      "Cumplimiento",
      "Autorregulación publicitaria",
      "Sostenibilidad y propósito de la marca",
      "Cadena de producción publicitaria",
      "Adecuada representación de género en la comunicación comercial",
      "Ecosistema digital",
      "Comunicación responsable a través de influenciadores",
      "Protección de niños, niñas, adolescentes",
    ];

    //  Move to the next general page
    if (pageFlow.includes(selectedItem)) {
      const currentIndex = pageFlow.indexOf(selectedItem);
      const nextItem = pageFlow[(currentIndex + 1) % pageFlow.length];
      setSelectedItem(nextItem);
      handleItemClick(nextItem);
      return;
    }

    // Move to the next principle
    if (allPrinciplesData.includes(selectedItem)) {
      const currentIndex = allPrinciplesData.indexOf(selectedItem);
      const nextPrinciple =
        allPrinciplesData[(currentIndex + 1) % allPrinciplesData.length];
      const principle = listOfPrinciples.data.data.find(
        (p) => p.title === nextPrinciple
      );
      setSelectedItem(nextPrinciple);
      setSelectedComponent(<SinglePrinciple item={principle} />);
      return;
    }
  };
  
  return (
    <>
      <Box sx={{ ml: "344px" }}>
        <div className="tool-guide">
          <div className="sidebar" style={{ flex: "0 0 21%" }}>
            <ul
              style={{ borderBottom: "1px solid black", paddingBottom: "10px" }}
            >
              <li
                className={
                  selectedItem === "Información de la empresa"
                    ? "selected-item"
                    : "list-text"
                }
                onClick={() => handleItemClick("Información de la empresa")}
              >
                <img
                  src="/business.png"
                  alt="business"
                  className="list-image"
                />
                Información de la empresa
              </li>
              <li
                className={
                  selectedItem === "Introducción"
                    ? "selected-item"
                    : "list-text"
                }
                onClick={() => handleItemClick("Introducción")}
              >
                <img src="/intro.png" alt="intro" className="list-image" />
                Introducción
              </li>
              <li
                className={
                  selectedItem === "Objetivos" ? "selected-item" : "list-text"
                }
                onClick={() => handleItemClick("Objetivos")}
              >
                <img
                  src="/goal-alt.png"
                  alt="goal-alt"
                  className="list-image"
                />
                Objetivos
              </li>
              <li
                className={
                  selectedItem === "Principios" ? "selected-item" : "list-text"
                }
                onClick={() => handleItemClick("Principios")}
              >
                <img src="/law.png" alt="law" className="list-image" />
                Principios
              </li>
              <li
                className={
                  selectedItem === "Metodología y guía"
                    ? "selected-item"
                    : "list-text"
                }
                onClick={() => handleItemClick("Metodología y guía")}
              >
                <img
                  src="/metodology.png"
                  alt="metodology"
                  className="list-image"
                />
                Metodología y guía
              </li>
              <li
                className={
                  selectedItem === "Glosario" ? "selected-item" : "list-text"
                }
                onClick={() => handleItemClick("Glosario")}
              >
                <img
                  src="/translate.png"
                  alt="translate"
                  className="list-image"
                />
                Glosario
              </li>
              <li
                className={
                  selectedItem === "Condiciones de uso"
                    ? "selected-item"
                    : "list-text"
                }
                onClick={() => handleItemClick("Condiciones de uso")}
              >
                <img
                  src="/checklist.png"
                  alt="checklist"
                  className="list-image"
                />
                Condiciones de uso
              </li>

              <li
                className={
                  selectedItem === "Reportes" ? "selected-item" : "list-text"
                }
                onClick={() => handleItemClick("Reportes")}
              >
                <img
                  src="/business.png"
                  alt="business"
                  className="list-image"
                />
                Reportes
              </li>
            </ul>
            <div
              style={{
                fontSize: "20px",
                margin: "15px 0px",
              }}
            >
              Diligenciamiento Huella{" "}
              <img
                style={{
                  width: "25px",
                  padding: "0px 0px 0px 10px",
                  cursor: "pointer",
                }}
                src="/arrow-down.png"
                alt="arrow"
                onClick={() => setPrinciplesDropdown(!principlesDropdown)}
              />
            </div>
            {principlesDropdown && (
              <>
                <ul>
                  {listOfPrinciples?.data?.data.map((principle, index) => (
                    <li
                      key={index}
                      className={
                        selectedItem === principle.title
                          ? "selected-item"
                          : "list-text"
                      }
                      onClick={() => handleItemPrinciples(principle)}
                    >
                      <img
                        src={principle?.icon}
                        alt={principle.title}
                        className="list-image"
                      />
                      {principle.title}
                    </li>
                  ))}
                </ul>
                <ul>
                  {" "}
                  <li
                    className={
                      selectedItem === "Histórico de data"
                        ? "selected-item"
                        : "list-text"
                    }
                    onClick={() => handleItemClick("Histórico de data")}
                  >
                    <img
                      src="/history_data.png"
                      alt="history_data"
                      className="list-image"
                    />
                    Histórico de data
                  </li>
                </ul>
              </>
            )}{" "}
          </div>

          <div
            className="main-content"
            style={{
              flex: "0 0 70%",
            }}
          >
            <div className="huella-cover-band">
              <img
                src="/cover.png"
                alt="header"
                style={{
                  width: "min(100%, 1120px)",
                  maxWidth: "1120px",
                  height: "140px",
                  objectFit: "cover",
                  display: "block",
                  flex: "0 1 1120px",
                  minWidth: "0",
                }}
              />
            </div>
            <div className="tool-guide_button-container">
              <button
                className="tool-guide_button"
                onClick={handlePagesNavigation}
              >
                {" "}
                SIGUIENTE
              </button>
            </div>
            <div
              ref={containerRef}
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {selectedComponent}
            </div>
            <div className="tool-guide_button-container">
              <button
                className="tool-guide_button-bottom"
                onClick={handlePagesNavigation}
              >
                {" "}
                SIGUIENTE
              </button>
            </div>
          </div>
        </div>
      </Box>
    </>
  );
};

export default ToolGuide;
